import createRoute         from '@widesk-ui/tools/createRoute';
import ExpirationTypeModel from '@models/shop/ExpirationTypeModel';

export default createRoute.table('/expiration_types', 'shop', 'ExpirationTypeTable', ExpirationTypeModel.localize('plural'));
